/**
 * @desc 根据月份查询月计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MonthRequest,
): Promise<defs.StandardReturn<defs.PlanMonthInfoResponse>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanInfoByMonth',
    data,
  });
}

export function mock(
  data: defs.MonthRequest,
): Promise<defs.StandardReturn<defs.PlanMonthInfoResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanInfoByMonth',
    data,
  });
}
